module.exports = __webpack_public_path__ + "static/img/088_TO8_1743_og.341266f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/088_TO8_1743_og.jpg
// module id = JnvN
// module chunks = 0